/** What the rest of the site needs to know about this game without loading it. Its name and
 * pitch are translated: `games.breaker.*` in src/locales/common.ts. */
export const BRICK_BREAKER = {
  /** Key for the stored best score and the game's strings. */
  id: "breaker",
} as const;
